var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitRiderIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 35,
    viewBox: "0 0 51 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_13634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3189 25.2264H1.42578V1.47266H25.85V6.06428V25.2264H16.2179",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0317 15.3614H15.6505V18.7483H11.6328V15.3614H8.24023V11.3381H11.6328V7.95117H15.6505V11.3381H19.0317V15.3614Z",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4472 25.2266H25.8496",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3346 25.2264H47.7733V17.5263C47.7733 16.6455 47.4153 15.8499 46.8357 15.2646C46.2503 14.6906 45.4548 14.3269 44.5739 14.3269C43.1305 14.3269 41.8747 13.3666 41.4882 11.9743L40.5165 8.41123C40.1301 7.02465 38.8742 6.05859 37.4308 6.05859H25.8438",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2736 34.1482C15.2206 34.1482 17.6096 31.7592 17.6096 28.8121C17.6096 25.8651 15.2206 23.4761 12.2736 23.4761C9.32654 23.4761 6.9375 25.8651 6.9375 28.8121C6.9375 31.7592 9.32654 34.1482 12.2736 34.1482Z",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7872 28.812C14.7872 30.1986 13.662 31.3238 12.2754 31.3238C10.8888 31.3238 9.76367 30.1986 9.76367 28.812C9.76367 27.4255 10.8888 26.3003 12.2754 26.3003C13.662 26.3003 14.7872 27.4255 14.7872 28.812Z",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3907 34.1482C39.3378 34.1482 41.7268 31.7592 41.7268 28.8121C41.7268 25.8651 39.3378 23.4761 36.3907 23.4761C33.4437 23.4761 31.0547 25.8651 31.0547 28.8121C31.0547 31.7592 33.4437 34.1482 36.3907 34.1482Z",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9024 28.812C38.9024 30.1986 37.7772 31.3238 36.3907 31.3238C35.0041 31.3238 33.8789 30.1986 33.8789 28.812C33.8789 27.4255 35.0041 26.3003 36.3907 26.3003C37.7772 26.3003 38.9024 27.4255 38.9024 28.812Z",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7749 25.2266H48.5591C49.0478 25.2266 49.5025 25.4255 49.8264 25.7494C50.1503 26.0733 50.3492 26.5279 50.3492 27.0166C50.3492 28.0054 49.5479 28.8067 48.5591 28.8067H41.7285",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0566 28.8066H17.6113",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42578 25.2266C1.42578 27.2098 3.03399 28.8067 5.00589 28.8067H6.92664",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7832 6.06378V3.33609C29.7832 1.85858 30.9709 0.670898 32.4484 0.670898C33.1815 0.670898 33.8577 0.966399 34.335 1.44943C34.8181 1.93246 35.1136 2.60302 35.1136 3.33609V6.06378",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7832 6.06396L30.3117 10.5647C30.4992 12.1558 31.846 13.3492 33.4429 13.3492H42.2738",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7735 18.748H25.8496",
    stroke: "#187C85",
    strokeWidth: 1.09855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_13634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.0589,
    height: 34.6133,
    fill: "white",
    transform: "translate(0.857422 0.103027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitRiderIcon2);
export default __webpack_public_path__ + "static/media/benefit-rider-icon2.046df527677f65506d418d7f9cc10448.svg";
export { ForwardRef as ReactComponent };